import React from 'react';
const IdentityContext = React.createContext();

export default IdentityContext;